import {ROUTE_PARAM_VALUES, ROUTE_PARAMS} from './route';

const ROOT = '/';
const AGE_GATE = '/age-gate';
const GET_STARTED_PAGE = '/get-started-page';
const PRE_LOGIN = '/pre-login';
const APP_INSTALLATION_GUIDE = '/app-installation-guide';
const LOGIN = '/login';
const HOME = '/home';
const CLUB = '/club';
const TERMS_OF_USE = '/terms-of-use';
const USAGE = '/usage';
const MY_ACCOUNT = '/my-account';
const THEME = '/theme';
const PREFERENCE_CENTER = '/preference-center';
const LANGUAGE = '/language';
const NOTIFICATIONS = '/notifications';
const PUSH_NOTIFICATIONS = '/consent-push-notifications';
const EXPERIENCE_SCORE_UWM = '/experience-score-uwm';
const SHOP = '/shop';
const UNSUPPORTED_BROWSER = '/unsupported-browser';

const DEVICE_SETTINGS = '/device-settings';
const DEVICE_FWU = `${DEVICE_SETTINGS}/firmware`;
const VIBRATION = `${DEVICE_SETTINGS}/vibration`;
const LED = `${DEVICE_SETTINGS}/led`;
const PAUSE_MODE = `${DEVICE_SETTINGS}/pause-mode`;
const FLEX_PUFF = `${DEVICE_SETTINGS}/flex-puff`;
const FLEX_BATTERY = `${DEVICE_SETTINGS}/flex-battery`;
const APPEARANCE = `${DEVICE_SETTINGS}/appearance`;
const AUTO_START = `${DEVICE_SETTINGS}/auto-start`;
const SMART_GESTURES = `${DEVICE_SETTINGS}/smart-gestures`;
const DEVICE_LOCK = `${DEVICE_SETTINGS}/lock`;
const VIBRATION_INTENSITY = `${DEVICE_SETTINGS}/vibration-intensity`;
const TUNABILITY = `${DEVICE_SETTINGS}/tunability`;
const REMEMBER_HEATING_PROFILE = `${DEVICE_SETTINGS}/remember-heating-profile`;
const RANGE_MODE = `${DEVICE_SETTINGS}/range-mode`;

const DEVICE = '/device';
const DEVICE_CONNECTED = `${DEVICE}/connected`;
const DEVICE_CONNECTION = `${DEVICE}/connection`;
const DEVICE_CONNECTION_ERROR = `${DEVICE}/connection-error`;
const DEVICE_REGISTRATION = `${DEVICE}/registration`;
const DEVICE_REGISTRATION_ERROR = `${DEVICE}/registration-error`;
const DEVICE_REGISTRATION_OWNERSHIP_ERROR = `${DEVICE}/registration-ownership-error`;

const DEVICE_FWU_CHECK = `${DEVICE_FWU}/check`;
const DEVICE_FWU_START = `${DEVICE_FWU}/start`;
const DEVICE_FWU_PROGRESS = `${DEVICE_FWU}/progress`;
const DEVICE_FWU_FINISHED = `${DEVICE_FWU}/finished`;
const DEVICE_FWU_ERROR = `${DEVICE_FWU}/error`;

const CLUB_WELCOME = `${CLUB}/welcome`;
const CLUB_BADGE = `${CLUB}/badge`;
const CLUB_SWITCH = `${CLUB}/switch`;

const CONNECTION_GUIDE = '/connection-guide';
const CONNECTION_GUIDE_INTRO = `${CONNECTION_GUIDE}/:${ROUTE_PARAMS.CONNECTION_TYPE}/intro`;
const CONNECTION_GUIDE_STEPS = `${CONNECTION_GUIDE}/:${ROUTE_PARAMS.CONNECTION_TYPE}/steps`;
const WIFI_CONNECTION_GUIDE_INTRO = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.WIFI}/intro`;
const WIFI_CONNECTION_GUIDE_STEPS = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.WIFI}/steps`;
const LTE_CONNECTION_GUIDE_INTRO = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.LTE}/intro`;
const LTE_CONNECTION_GUIDE_STEPS = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.LTE}/steps`;
const SIDEWALK_CONNECTION_GUIDE_INTRO = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.SIDEWALK}/intro`;
const SIDEWALK_CONNECTION_GUIDE_STEPS = `${CONNECTION_GUIDE}/${ROUTE_PARAM_VALUES.SIDEWALK}/steps`;
const NETWORK_SETUP = `${CONNECTION_GUIDE}/network-setup`;
const NETWORK_SETUP_NETWORKS = `${NETWORK_SETUP}/networks`;
const NETWORK_SETUP_SEARCH = `${NETWORK_SETUP}/search`;
const NETWORK_SETUP_CREDENTIALS = `${NETWORK_SETUP}/credentials`;
const NETWORK_SETUP_NETWORK_ERROR = `${NETWORK_SETUP}/network-error`;
const NETWORK_SETUP_SEARCH_ERROR = `${NETWORK_SETUP}/search-error`;
const NETWORK_SETUP_NO_INTERNET_ERROR = `${NETWORK_SETUP}/no-internet-error`;

const ADVANCED_DIAGNOSTIC = '/advanced-diagnostic';
const ADVANCED_DIAGNOSTIC_ENTRY_POINT = `${ADVANCED_DIAGNOSTIC}/entry-point`;

const TEST_ONBOARDING = '/test-onboarding';
const DEV_TOOLS = '/dev-tools';
const AI_ASSISTANT_TEST = '/ai';

const RETAIL = '/retail';
const RETAIL_DASHBOARD = `${RETAIL}/dashboard`;
const RETAIL_REWARDS = `${RETAIL}/rewards`;
const MESSAGE_CENTER = '/inbox';

export default {
    ROOT,
    AGE_GATE,
    GET_STARTED_PAGE,
    PRE_LOGIN,
    APP_INSTALLATION_GUIDE,
    LOGIN,
    HOME,
    CLUB,
    CLUB_WELCOME,
    CLUB_BADGE,
    CLUB_SWITCH,
    CONNECTION_GUIDE,
    CONNECTION_GUIDE_INTRO,
    CONNECTION_GUIDE_STEPS,
    TERMS_OF_USE,
    DEVICE_CONNECTION,
    DEVICE_CONNECTED,
    DEVICE,
    DEVICE_SETTINGS,
    DEVICE_REGISTRATION,
    DEVICE_REGISTRATION_ERROR,
    DEVICE_REGISTRATION_OWNERSHIP_ERROR,
    DEVICE_CONNECTION_ERROR,
    USAGE,
    MY_ACCOUNT,
    DEVICE_FWU,
    PREFERENCE_CENTER,
    VIBRATION,
    LED,
    PAUSE_MODE,
    FLEX_PUFF,
    FLEX_BATTERY,
    APPEARANCE,
    AUTO_START,
    SMART_GESTURES,
    DEVICE_LOCK,
    VIBRATION_INTENSITY,
    TUNABILITY,
    REMEMBER_HEATING_PROFILE,
    RANGE_MODE,
    DEVICE_FWU_CHECK,
    DEVICE_FWU_START,
    DEVICE_FWU_PROGRESS,
    DEVICE_FWU_FINISHED,
    DEVICE_FWU_ERROR,
    THEME,
    LANGUAGE,
    NOTIFICATIONS,
    PUSH_NOTIFICATIONS,
    EXPERIENCE_SCORE_UWM,
    WIFI_CONNECTION_GUIDE_INTRO,
    WIFI_CONNECTION_GUIDE_STEPS,
    LTE_CONNECTION_GUIDE_INTRO,
    LTE_CONNECTION_GUIDE_STEPS,
    SIDEWALK_CONNECTION_GUIDE_INTRO,
    SIDEWALK_CONNECTION_GUIDE_STEPS,
    NETWORK_SETUP,
    NETWORK_SETUP_NETWORKS,
    NETWORK_SETUP_SEARCH,
    NETWORK_SETUP_CREDENTIALS,
    NETWORK_SETUP_NETWORK_ERROR,
    NETWORK_SETUP_NO_INTERNET_ERROR,
    NETWORK_SETUP_SEARCH_ERROR,
    ADVANCED_DIAGNOSTIC,
    ADVANCED_DIAGNOSTIC_ENTRY_POINT,
    TEST_ONBOARDING,
    DEV_TOOLS,
    AI_ASSISTANT_TEST,
    RETAIL,
    RETAIL_DASHBOARD,
    RETAIL_REWARDS,
    MESSAGE_CENTER,
    SHOP,
    UNSUPPORTED_BROWSER,
};
